import { ReactNode } from 'react';

import { cn } from '@/lib/cn';

import { copyToClipboard } from '../lib/copyToClipboard';
import { useLogger } from '../lib/log';
import { CopyButton } from './CopyButton';

type CopyableFieldProps = {
    displayValue: ReactNode;
    copyValue: string;
    fieldType: 'nationalIdentifier' | 'phoneNumber' | 'address';
    className?: string;
};

export const CopyableField = ({
    displayValue,
    copyValue,
    fieldType,
    className,
}: CopyableFieldProps) => {
    const log = useLogger();
    return (
        <div
            className={cn(
                'inline-flex items-center font-bold text-inherit',
                className,
            )}
        >
            {displayValue}
            <CopyButton
                onClick={() => {
                    void copyToClipboard(copyValue);
                    void log(fieldType);
                }}
            />
        </div>
    );
};
